<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    赤湾站<br>
站点介绍<br>
赤湾站是2号线与5号线的换乘站，位于平南铁路蛇口西站疏港路西侧，赤湾山和小南山之间的赤湾村片区，赤湾六路和港航路北侧的仓储地块内，设置在垂直于港航路北面的规划路下，基本南北向布置。 赤湾站为地下车站， 车站共有4个出入口，站厅设置有公共洗手间、商铺，能为乘坐地铁出行的乘客以及有需要的市民提供便利。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	--	--	2号线	2分35秒	5分45秒<br>
莲塘	06:04	23:00	2号线	2分35秒	5分45秒<br>
赤湾	--	--	5号线	3分钟	5分25秒<br>
黄贝岭	06:12	23:00	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	--	--	2号线	4分钟	5分钟<br>
莲塘	06:04	23:00	2号线	4分钟	5分钟<br>
赤湾	--	--	5号线	4分钟	6分钟<br>
黄贝岭	06:18	23:00	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	--	--	2号线	4分钟	5分钟<br>
莲塘	06:04	00:00	2号线	4分钟	5分钟<br>
赤湾	--	--	5号线	4分钟	6分钟<br>
黄贝岭	06:18	00:00	5号线	4分钟	6分钟<br><br>
<br>
站点出口信息<br><br>
C出入口:<br>
港航路、赤湾村、兴海大道西侧（南）、罗湖保安公司地铁安检大队、顺生物流蛇口仓库<br><br>
D出入口:<br>
兴海大道西侧（北）、蛇口站<br><br>
B出入口:<br>
左炮台路北侧、赤湾六路北侧（东）、港航路北侧（东）、港机大楼、山海津<br><br>
E出入口:<br>
赤湾六路北侧（西）、赤湾学校、山语海苑<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 赤湾地铁站<br>
B945、M489<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


